// extracted by mini-css-extract-plugin
export default {"tabnavigator":"d135e71b5c1f5fe4732e","header":"e69b158ef270e7c4b430","container":"d344b22a60996f20cee4","indicator":"e8980e99ae6daeba7d30"};